import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Cookie } from 'lucide-react';
import { COOKIE_KEY, COMPANY_LEGAL, getCookieConsent, applyConsentToGtag } from '../../data/legal';

const save = (analytics, marketing) => {
  const v = { necessary: true, analytics, marketing, version: COMPANY_LEGAL.consentVersion, date: new Date().toISOString() };
  localStorage.setItem(COOKIE_KEY, JSON.stringify(v));
  applyConsentToGtag(v);
  window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: v }));
  return v;
};

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [prefs, setPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const existing = getCookieConsent();
    if (!existing || existing.version !== COMPANY_LEGAL.consentVersion) setShow(true);
    else { setAnalytics(!!existing.analytics); setMarketing(!!existing.marketing); }
    const open = () => { const e = getCookieConsent(); if (e) { setAnalytics(!!e.analytics); setMarketing(!!e.marketing); } setPrefs(true); setShow(true); };
    window.addEventListener('open-cookie-prefs', open);
    return () => window.removeEventListener('open-cookie-prefs', open);
  }, []);

  if (!show) return null;

  const acceptAll = () => { save(true, true); setShow(false); };
  const rejectAll = () => { save(false, false); setShow(false); };
  const savePrefs = () => { save(analytics, marketing); setShow(false); };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto rounded-2xl border border-slate-200 bg-white shadow-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shrink-0"><Cookie size={20} className="text-[#1a4b8c]" /></div>
          <div className="flex-1 space-y-3">
            <div>
              <p className="font-bold text-slate-800">Informativa cookie</p>
              <p className="text-sm text-slate-600">Usiamo cookie tecnici necessari al funzionamento del sito. Con il tuo consenso utilizziamo anche cookie analitici e di marketing per misurare le campagne di recruiting. Puoi accettare, rifiutare o personalizzare. Il consenso ai cookie è indipendente dall'invio della candidatura. Dettagli nell'<a href="/lavora-con-noi/privacy" className="text-[#1a4b8c] underline" target="_blank" rel="noreferrer">Informativa Privacy &amp; Cookie</a>.</p>
            </div>

            {prefs && (
              <div className="space-y-2 border-t pt-3" data-testid="cookie-prefs">
                <label className="flex items-start gap-2 text-sm text-slate-500"><input type="checkbox" checked disabled className="mt-1" /> <span><b className="text-slate-700">Necessari</b> (sempre attivi): indispensabili per il funzionamento del sito e l'invio della candidatura.</span></label>
                <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={analytics} onChange={e => setAnalytics(e.target.checked)} className="mt-1" data-testid="cookie-analytics" /> <span><b>Analitici</b>: statistiche anonime/pseudonime su visite e candidature (es. Google Analytics).</span></label>
                <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={marketing} onChange={e => setMarketing(e.target.checked)} className="mt-1" data-testid="cookie-marketing" /> <span><b>Marketing</b>: misurazione delle campagne pubblicitarie (es. Google Ads, Meta, LinkedIn).</span></label>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
              <Button size="sm" onClick={acceptAll} data-testid="cookie-accept-all">Accetta tutti</Button>
              <Button size="sm" variant="outline" onClick={rejectAll} data-testid="cookie-reject-all">Rifiuta non necessari</Button>
              {prefs
                ? <Button size="sm" variant="outline" onClick={savePrefs} data-testid="cookie-save-prefs">Salva preferenze</Button>
                : <Button size="sm" variant="ghost" onClick={() => setPrefs(true)} data-testid="cookie-customize">Personalizza</Button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
